export default __webpack_public_path__ + "static/alaska-9607349ebb3d2734b302b3c403a8af45.svg";